<div class="pedido-itens-modal-campanha">
  <!-- Título -->

  <div class="d-flex flex-wrap justify-content-between">
    <div class="d-flex flex-column">
      <div>
        <span class="badge badge-warning produto_campanha_selecionado_grupo_estoque pedido-itens-badge pedido-itens-badge-warn">{{ produtoCampanhaSelecionado.grupo_estoque }}</span>
      </div>

      <div class="adicionar_itens_descricao_nome">
        <b>{{ produtoCampanhaSelecionado.name }}</b>
      </div>
    </div>

    @if (produtoCampanhaSelecionado.qtde_minima > 0) {
      <div class="d-flex flex-column justify-content-end align-items-end">
        <div class="produto_campanha_selecionado_qtde">
          Qtde Mínima de Itens: {{ produtoCampanhaSelecionado.qtde_minima }}
        </div>
        <div class="produto_campanha_selecionado_qtde">
          Qtde Atual de Itens: {{ produtoCampanhaSelecionado.qtde_minima_atual }}
        </div>
      </div>
    }
  </div>

  <hr class="mt-2 mb-2" />

  @if (produtoCampanhaSelecionado.produtos_vinculados.length > 10) {
    <form [formGroup]="formFiltroProdutoCampanha" (ngSubmit)="filtroSubmetido.emit()">
      <div class="form-row">
        <!-- Descrição -->
        <div class="form-group col-sm-9">
          <label class="text-secondary"><b>Descrição:</b></label>
          <input class="form-control form-control-sm" type="text" name="produto_campanha_descricao" [ngClass]="{ 'is-invalid': enviadoProdutoCampanha && fa.descricao.errors?.required }" formControlName="descricao" />
          @if (enviadoProdutoCampanha && fa.descricao.errors?.required) {
            <div class="erro pt-1">Descrição em branco!</div>
          }
        </div>
        <div class="col-sm-3">
          <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
          @if (filtrandoProdutoCampanha) {
            <button class="btn btn-secondary btn_filtro" type="button" (click)="filtroCancelado.emit()">Cancelar</button>
          }
        </div>
      </div>
    </form>
    <hr class="mt-2 mb-2" />
  }

  <!-- Produto (Campanha) -->

  <div class="pedido-itens-card pedido-itens-modal-campanha-grid">
    <div class="table-responsive">
      <table class="table table-sm pedido-itens-modal-campanha-tabela">
        <thead>
          <tr>
            <th>Produto</th>
            <th class="text-center tabela_borda">Estoque</th>
            @if (produtoCampanhaSelecionado.existe_lote) {
              <th class="text-center tabela_borda">Lote</th>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao == 'B') {
              <th class="text-right tabela_borda">Por: R$</th>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
              <th class="text-right tabela_borda">De: R$</th>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
              <th class="text-right tabela_borda">Por: R$</th>
            }
            @if (produtoCampanhaSelecionado.grupo_estoque == combo && produtoCampanhaSelecionado.qtde_minima_existente) {
              <th class="text-center tabela_borda">Qtde Mínima</th>
            }
            @if (produtoCampanhaSelecionado.grupo_estoque == combo) {
              <th class="text-center tabela_borda">Qtde</th>
            }
            @if (produtoCampanhaSelecionado.grupo_estoque != combo) {
              <th class="text-center tabela_borda">Qtde</th>
            }
            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <th class="text-right tabela_borda">Fator: R$</th>
            }
            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <th class="text-right tabela_borda bg_tabela_danger">C/ Fator: R$</th>
            }
            @if (exibirPontuacao) {
              <th class="text-right tabela_borda bg_tabela_warning">Pontuação</th>
            }
            <th class="text-right tabela_borda">Sub-Total: R$</th>
            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
              <th class="text-right tabela_borda">C/ Imposto: R$</th>
            }
          </tr>
        </thead>

        <tbody>
          @for (produto_vinculado of produtoCampanhaSelecionado.produtos_vinculados; track produto_vinculado; let i = $index) {
            @if (produto_vinculado.exibir && !produto_vinculado.bonificacao) {
              <tr>
                <td class="d-flex" data-label="Produto">
                  <div class="produto_campanha_selecionado_descricao m-0">{{ produto_vinculado.name }}</div>
                  @if (produtoCampanhaSelecionado.preco_bonificacao == 'B' && !produtoCampanhaSelecionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                    @if (!produtoCampanhaSelecionado.bonificacao_multiplicavel) {
                      <div class="pl-2">
                        <span class="badge badge-success produto_campanha_selecionado_produto_bonificado pedido-itens-badge pedido-itens-badge-ok">+{{ produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel == null ? 0 : produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel }} UNIDADE GRÁTIS</span>
                      </div>
                    }
                    @if (produtoCampanhaSelecionado.bonificacao_multiplicavel) {
                      <div class="pl-2">
                        <span class="badge badge-success produto_campanha_selecionado_produto_bonificado pedido-itens-badge pedido-itens-badge-ok">+{{ produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel == null ? 0 : produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel }} {{ produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel > 1 ? 'UNIDADES' : 'UNIDADE' }} GRÁTIS</span>
                      </div>
                    }
                  }
                </td>
                @if (produto_vinculado.qtde_lote == 0) {
                  <td class="text-center tabela_borda" data-label="Estoque">
                    <div class="produto_campanha_selecionado_campanha_estoque">{{ produto_vinculado.estoque }}</div>
                  </td>
                }
                @if (produto_vinculado.qtde_lote > 0 && produto_vinculado.id_lote != null) {
                  <td class="text-center tabela_borda" data-label="Estoque">
                    <div class="produto_campanha_selecionado_campanha_estoque">{{ produto_vinculado.estoque_lote }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.existe_lote) {
                  <td class="text-center tabela_borda" data-label="Lote">
                    <div class="produto_campanha_selecionado_nome_lote m-0">{{ produto_vinculado.nome_lote }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.preco_bonificacao == 'B') {
                  <td class="text-right tabela_borda" data-label="Por: R$">
                    <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.price_promotional | currency: 'BRL' }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
                  <td class="text-right tabela_borda" data-label="De: R$">
                    <div class="produto_campanha_selecionado_campanha_valor_promocional">{{ produto_vinculado.price | currency: 'BRL' }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
                  <td class="text-right tabela_borda" data-label="Por: R$">
                    <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.price_promotional | currency: 'BRL' }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.grupo_estoque == combo && produtoCampanhaSelecionado.qtde_minima_existente) {
                  <td class="text-center tabela_borda" data-label="Qtde Mínima">
                    <div class="produto_campanha_selecionado_campanha_qtde_fixa">{{ produto_vinculado.qtde_minima == 0 ? '-' : produto_vinculado.qtde_minima }}</div>
                  </td>
                }
                @if (produtoCampanhaSelecionado.grupo_estoque == combo) {
                  <td class="produto_campanha_selecionado_campanha_qtde tabela_borda" data-label="Qtde">
                    @if (!produto_vinculado.bonificacao) {
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center">
                          <i class="fa fa-minus produto_campanha_selecionado_campanha_qtde_acao pr-2" (click)="qtdeProdutoDecrementada.emit(produto_vinculado.id)"></i>
                          <input class="form-control form-control-sm" type="number" min="1" step="1" name="campanha_qtde_{{ i }}" (focusout)="qtdeProdutoValidada.emit(produto_vinculado.id)" [ngClass]="{ 'is-invalid': produto_vinculado.erro_qtde }" [(ngModel)]="produtoCampanhaSelecionado.produtos_vinculados[i].qtde" />
                          <i class="fa fa-plus produto_campanha_selecionado_campanha_qtde_acao pl-2" (click)="qtdeProdutoIncrementada.emit(produto_vinculado.id)"></i>
                        </div>
                        @if (produto_vinculado.multiplo != null && produto_vinculado.multiplo != 0 && produto_vinculado.multiplo != 1) {
                          <div class="aviso pt-1">Múltipla de {{ produto_vinculado.multiplo }}...</div>
                        }
                        @if (produto_vinculado.erro_qtde) {
                          <div class="erro pt-1">Qtde inválida!</div>
                        }
                      </div>
                    }
                  </td>
                }
                @if (produtoCampanhaSelecionado.grupo_estoque != combo) {
                  <td class="produto_campanha_selecionado_campanha_qtde text-center tabela_borda" data-label="Qtde">
                    <div class="produto_campanha_selecionado_campanha_qtde_fixa">
                      <div class="d-flex flex-column">
                        <div>{{ produto_vinculado.qtde_minima }}</div>
                        @if (produto_vinculado.erro_qtde) {
                          <div class="erro pt-1">Qtde inválida!</div>
                        }
                      </div>
                    </div>
                  </td>
                }
                @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
                  <th class="text-right tabela_borda" data-label="Fator: R$">
                    @if (produto_vinculado.aplica_fator_financeiro) {
                      <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.valor_fator_financeiro_unitario | currency: 'BRL' }}</div>
                    }
                    @if (!produto_vinculado.aplica_fator_financeiro) {
                      <div class="produto_campanha_selecionado_campanha_valor">-</div>
                    }
                  </th>
                }
                @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
                  <td class="text-right tabela_borda bg_tabela_danger" data-label="C/ Fator: R$">
                    @if (produto_vinculado.aplica_fator_financeiro) {
                      <div class="produto_campanha_selecionado_campanha_valor"><b>{{ produto_vinculado.valor_fator_financeiro_produto | currency: 'BRL' }}</b></div>
                    }
                    @if (!produto_vinculado.aplica_fator_financeiro) {
                      <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.price_promotional | currency: 'BRL' }}</div>
                    }
                  </td>
                }
                @if (exibirPontuacao) {
                  <td class="text-right tabela_borda bg_tabela_warning" data-label="Pontuação">
                    <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.pontuacao_calculada | number: '1.2-2' }}</div>
                  </td>
                }
                <td class="text-right tabela_borda" data-label="Sub-Total: R$">
                  <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.valor_fator_financeiro_total | currency: 'BRL' }}</div>
                </td>
                @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                  <td class="text-right tabela_borda" data-label="C/ Imposto: R$">
                    <div class="produto_campanha_selecionado_campanha_valor">{{ produto_vinculado.valor_imposto_total | currency: 'BRL' }}</div>
                  </td>
                }
              </tr>
            }
          }
        </tbody>

        <tfoot>
          <tr>
            <td class="tabela_borda_inferior"></td>
            <td class="tabela_borda_inferior"></td>
            @if (produtoCampanhaSelecionado.existe_lote) {
              <td class="tabela_borda_inferior"></td>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao == 'B') {
              <td class="tabela_borda_inferior"></td>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
              <td class="tabela_borda_inferior"></td>
            }
            @if (produtoCampanhaSelecionado.preco_bonificacao != 'B') {
              <td class="tabela_borda_inferior"></td>
            }
            @if (produtoCampanhaSelecionado.grupo_estoque == combo && produtoCampanhaSelecionado.qtde_minima_existente) {
              <td class="tabela_borda_inferior"></td>
            }

            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <th class="tabela_borda_inferior"></th>
            }
            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <th class="tabela_borda_inferior"></th>
            }
            @if (exibirPontuacao) {
              <th class="tabela_borda_inferior"></th>
            }

            @if (produtoCampanhaSelecionado.grupo_estoque == combo) {
              <td class="text-right tabela_borda_inferior">
                <h6 class="m-0"><b>Sub-Total:</b></h6>
              </td>
            }

            @if (produtoCampanhaSelecionado.grupo_estoque != combo) {
              <td class="text-right tabela_borda_inferior">
                <h6 class="m-0"><b>Sub-Total:</b></h6>
              </td>
            }

            <td class="text-right tabela_borda tabela_borda_inferior">
              @if (produtoCampanhaSelecionado.grupo_estoque == combo) {
                <div class="produto_campanha_selecionado_campanha_valor">{{ produtoCampanhaSelecionado.valor_total_produtos_vinculados | currency: 'BRL' }}</div>
              }

              @if (produtoCampanhaSelecionado.grupo_estoque != combo) {
                <div class="produto_campanha_selecionado_campanha_valor">{{ produtoCampanhaSelecionado.valor_fator_financeiro_produto | currency: 'BRL' }}</div>
              }
            </td>

            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
              <td class="text-right tabela_borda tabela_borda_inferior">
                <div class="produto_campanha_selecionado_campanha_valor">{{ produtoCampanhaSelecionado.valor_imposto_produto | currency: 'BRL' }}</div>
              </td>
            }
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- Qtde -->

  <div class="borda_superior pt-2 pb-2">
    <div class="d-flex justify-content-end">
      <div class="col-sm-2 p-0 pedido-itens-modal-campanha-qtde-col">
        <label><b>Qtde:</b></label>

        <div class="d-flex align-items-center">
          <i class="fa fa-minus produto_campanha_selecionado_campanha_qtde_acao pr-2" (click)="qtdeDecrementada.emit(produtoCampanhaSelecionado.id_campanha)"></i>

          <input class="form-control form-control-sm" type="number" min="1" step="1" name="qtde" (focusout)="qtdeValidada.emit()" [ngClass]="{ 'is-invalid': produtoCampanhaSelecionado.erro_qtde }" [(ngModel)]="produtoCampanhaSelecionado.qtde" />

          <i class="fa fa-plus produto_campanha_selecionado_campanha_qtde_acao pl-2" (click)="qtdeIncrementada.emit(produtoCampanhaSelecionado.id_campanha)"></i>
        </div>

        @if (produtoCampanhaSelecionado.erro_qtde) {
          <div class="erro pt-1">Qtde inválida!</div>
        }
      </div>
    </div>
  </div>

  <!-- Bonificação -->

  @if (produtoCampanhaSelecionado.preco_bonificacao == 'B' && produtoCampanhaSelecionado.bonificacao_selecionavel) {
    <div class="borda_superior pt-2 pb-2">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Bonificação:</b></label>
          <select class="form-control form-control-sm" name="bonificacao" (change)="bonificacaoAlterada.emit($event.target.value)" [ngClass]="{ 'is-invalid': bonificacaoInvalida }">
            <option value="0"></option>
            @for (opcao of produtoCampanhaSelecionado.produtos_vinculados; track opcao) {
              <option [value]="opcao.id" [selected]="opcao.bonificacao_selecionada" [hidden]="!opcao.bonificacao || !opcao.exibir" [disabled]="!opcao.bonificacao || !opcao.exibir">{{ opcao.qtde }} {{ opcao.qtde > 1 ? 'UNIDADES' : 'UNIDADE' }} DE {{ opcao.name.toUpperCase() }}</option>
            }
          </select>
          @if (bonificacaoInvalida) {
            <div class="erro pt-1">Bonificação inválida!</div>
          }
        </div>
      </div>
    </div>
  }
</div>
